var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download"},[_c('Category',{on:{"handle-category":_vm.handleCategoryChange}}),_c('PublicList',{attrs:{"text":"下载","category":_vm.category,"list":_vm.downloadList,"onMoreLoad":_vm.onMoreReadList,"isShow":_vm.isShow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }